import React from 'react';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <section className="w-full bg-sand px-5 py-20 sm:py-28" data-id="element-16" data-mp="pjpx9t6ljn8q">
      <div className="mx-auto max-w-3xl" data-id="element-17" data-mp="pj6c83lngiqh">
        <h2 className="text-center font-display text-[1.6rem] font-black leading-tight tracking-tight text-ink sm:text-[2.2rem]" data-id="element-18" data-mp="avd0itzoq0d6">
          <span aria-hidden="true" data-id="element-19" data-mp="fsv9ulhm6hlp">🎁 </span>Les 5 Bonus Officiels Inclus
        </h2>
        <p className="mt-2 text-center text-sm text-ink/60" data-id="element-20" data-mp="1u59mwzi01t4">
          Valeur totale{' '}
          <span className="font-bold text-amber-600 line-through" data-id="element-21" data-mp="5wi7kz806vfc">85 USD</span>{' '}
          — Inclus aujourd&apos;hui{' '}
          <span className="font-bold text-brand" data-id="element-22" data-mp="3o2wrrfwv81m6">GRATUITEMENT</span> avec votre
          commande
        </p>

        <ol className="mt-9 space-y-4" data-id="element-23" data-mp="3t1817pj90a3v">
          {bonuses.map((bonus, index) => <li key={bonus.title} className="flex items-center gap-5 rounded-2xl bg-white p-5 shadow-[0_1px_3px_rgba(20,17,15,0.06)] sm:gap-6 sm:p-6" data-id="element-24" data-mp="1mbjqr1y0qdve" data-mpi={index}>
              <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-brand font-display text-sm font-bold text-white" data-id="element-25" data-mp="3idemc6jw445e">
                {index + 1}
              </span>
              <img src={bonus.cover} alt="" className="h-40 w-32 shrink-0 object-contain sm:h-52 sm:w-44" data-id="element-26" data-mp="3r5oxbq2m0dnp" />
              <div data-id="element-27" data-mp="2zfamk2pw7hg9">
                <h3 className="font-display text-base font-bold leading-snug text-ink sm:text-lg" data-id="element-28" data-mp="2zesl8rodid1h">
                  {bonus.title}
                </h3>
                <p className="mt-1.5 text-xs font-bold" data-id="element-29" data-mp="2uiu0de297d5t">
                  <span className="text-amber-600 line-through" data-id="element-30" data-mp="38hbmj7cighlm">
                    valeur {bonus.was}
                  </span>{' '}
                  <span className="text-brand" data-id="element-31" data-mp="33ja32lb6ag9m">GRATUIT</span>
                </p>
                <p className="mt-2 text-xs leading-relaxed text-ink/55 sm:text-sm" data-id="element-32" data-mp="noghfbrfznvm">
                  {bonus.text}
                </p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}